export enum ScheduleType {
    None = 0,
    New = 1,
    Edit = 2,
    MassEdit = 3,
    SCard = 4,
    WCard = 5
}

export enum SchedulePermission {
    Show = 0,
    Add = 1
}

export enum SupplyCardStatus{
    None = 0,
    TableEdit = 1,
    NewAdd = 2,
    Show
}



// WEBPACK FOOTER //
// ./src/app/supply-schedules/models/sched-type.ts